const filterSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon stroke-width="1.2" points="8.98 10.38 7.02 12 7.02 8.34 4 3.68 12 3.68 8.98 8.34"/></svg>',
};

export { filterSubtle as default };
